import { SelectionChangedEvent } from "ag-grid-community";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { INITIAL_RECAL_PROCESS_AND_GEN_COL_DEF_AQCT, INITIAL_RECAL_PROCESS_AND_GEN_COL_DEF_SAPT, transferRowData } from "presentation/constant/Recalculation/RecalProcessAndGenColumnDefinition";
import { useRecalProcessAndGenVM } from "presentation/hook/Recalculation/useRecalProcessAndGenVM";
import { useRecalProcessAndGenMaintenanceTracked } from "presentation/store/Recalculation/RecalProcessAndGenMaintenanceProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef } from "react";


const RecalProcessAndGenTablePanel: React.FC = () => {
    const [recalProcessAndGenState] = useRecalProcessAndGenMaintenanceTracked();
    const recalProcessAndGenVM = useRecalProcessAndGenVM();
    const { recalProcessAndGenList, isShowGeneratePanel, isShowSubmitPanel, isShowEditPanel } = recalProcessAndGenState;
    const gridRef: any = useRef(null);
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        recalProcessAndGenVM.updateSelectedRows(selectedRows);
    }, [recalProcessAndGenVM])


    const isRowSelectable = useCallback((params: any) => {
        return !isShowGeneratePanel && !isShowSubmitPanel && !isShowEditPanel;
    }, [isShowEditPanel, isShowGeneratePanel, isShowSubmitPanel]);


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const customRule = {
        // '.recal-cannot-submit-row': (rowParams: any) => (!rowParams.data?.groupNo),
        'recal-submit-row': (rowParams: any) => (rowParams.data?.groupNo && (rowParams.data?.groupNo === 3 || rowParams.data?.groupNo === 4)),
    };

    const memoTable = useMemo(() => {
        return (
            <>
                <NbisTable
                    headerLabel={'Recalculation List * The gray background color record does not allow to submit and generate.'}
                    id='recal-process-and-gen-table'
                    isNewColumnSetting={true}
                    columns={((operatingUnit === 'SAPT' || operatingUnit === 'KICT') ? INITIAL_RECAL_PROCESS_AND_GEN_COL_DEF_SAPT
                        : INITIAL_RECAL_PROCESS_AND_GEN_COL_DEF_AQCT)}
                    data={transferRowData(recalProcessAndGenList ?? [])}
                    showPaginator={false}
                    editable={false}
                    showAddIcon={false}
                    showDeleteButton={false}
                    showReloadIcon={false}
                    isScrollHighlighted={true}
                    selectionMode={true}
                    isRowHighligted={true}
                    rowSelection={"multiple"}
                    handleSelectionChanged={handleSelectionChange}
                    gridHeight="customHeight"
                    customHeight="calc(100vh - 125px)"
                    ref={gridRef}
                    rowClassRules={customRule}
                    handleRowSelectable={isRowSelectable}
                />
            </>
        );
    }, [customRule, handleSelectionChange, isRowSelectable, recalProcessAndGenList, operatingUnit])

    useEffect(() => {
        if (gridRef.current && gridRef.current.gridRef && gridRef.current.gridRef.current && gridRef.current.gridRef.current.api) {
            gridRef.current.gridRef.current.api.redrawRows();
        }
    }, [isShowGeneratePanel, isShowSubmitPanel, isShowEditPanel])

    return <><TableWrapper>
        {memoTable}
    </TableWrapper>
    </>;
}

export default memo(RecalProcessAndGenTablePanel);
